import Link from 'next/link';
import React from 'react';
import { get_dynamic_styles } from '../../constant/DynamicStyles';
import { get_dynamic_styles_with_default_value } from '../../constant/DynamicStylesWithDefaultValue';
import {
  CardBoxDefaultStyles,
  CardMainDefaultStyles,
} from '../../constant/default_styles/ProductDetailsStyles';
import { get_data_by_current_language } from '../../utils/GetDataByLanguage';
import { dynamic_text_convert } from '../../utils/dynamicTextConvert';

const AutoSlide = ({ data, styles }) => {
  // Preset number to multiply the list
  const listMultiplier = data?.list_multiplier ? data?.list_multiplier : 3; // You can change this number as needed

  // Function to create multiplied list
  const createMultipliedList = () => {
    const multipliedList = [];
    for (let i = 0; i < listMultiplier; i++) {
      data?.list?.forEach((item, index) => {
        multipliedList.push({
          ...item,
          uniqueKey: `${i}-${index}`, // Unique key for each copy
        });
      });
    }
    return multipliedList;
  };

  const multipliedList = createMultipliedList();

  return (
    <div style={get_dynamic_styles(styles?.main_styles)}>
      <div
        className="overflow-hidden"
        style={{
          display: styles?.box_styles?.display,
          ...get_dynamic_styles(styles?.box_styles),
        }}
      >
        <div
          className="flex animate-infinite-slide"
          style={{
            display: 'flex',
            width: 'max-content',
            ...get_dynamic_styles(styles?.box_styles),
          }}
        >
          {/* Multiplied list items */}
          {multipliedList?.map((item, index) => {
            return (
              <div
                className="flex-none"
                style={{
                  display: styles?.list_styles?.display,
                  ...get_dynamic_styles(styles?.list_styles),
                }}
                key={item?.uniqueKey || `item-${index}`}
              >
                {item?.icon && (
                  <img
                    style={get_dynamic_styles(styles?.icon_styles)}
                    src={item?.icon}
                    alt="image"
                  />
                )}
                {item?.text && (
                  <p
                    className="whitespace-nowrap"
                    style={get_dynamic_styles(styles?.text_styles)}
                  >
                    {get_data_by_current_language({
                      data_list: item?.translated_data,
                      key_name: 'text',
                      default_data: item?.text,
                    })}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>

      <style jsx>{`
        @keyframes infinite-slide {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .animate-infinite-slide {
          animation: infinite-slide 10s linear infinite;
        }

        .animate-infinite-slide:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

export default AutoSlide;
